import React from 'react';
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Typography } from '@mui/material';

const CheckboxGroup = ({ label, name, options, value, onChange, grouped }) => {
  const groupedOptions = grouped
    ? options.reduce((acc, option) => {
        const groupName = option.group || "Other";
        if (!acc[groupName]) acc[groupName] = [];
        acc[groupName].push(option);
        return acc;
      }, {})
    : { SingleGroup: options }; 
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend"><Typography variant="subtitle1" style={{ fontWeight: 'bold', marginTop: '8px' }}>
      {label}</Typography></FormLabel>
      {Object.keys(groupedOptions).map((groupName) => (
        <div key={groupName}>
          {grouped && <FormLabel component="legend">{groupName}</FormLabel>} {/* Only show group name if grouped */}
          <FormGroup>
            {groupedOptions[groupName].map((option) => (
              <FormControlLabel
                key={option.value}
                control={
                  <Checkbox
                    checked={value?.includes(option.value)}
                    onChange={onChange}
                    name={option.value}
                  />
                }
                label={option.label}
              />
            ))}
          </FormGroup>
        </div>
      ))}
    </FormControl>
  );
};

export default CheckboxGroup;
